<template>
  <v-group :zIndex='3' ref="container" :config="configGroup" @click="selected" @tap="selected" @touchend="dragend"
    @dragmove="dragmove" @dragstart="dragstart" @dragend="dragend">
    <v-group>
      <v-rect :zIndex='3' v-if="table.forme === 'rect'" ref="rect" :config="configRectangle"></v-rect>
      <v-circle :zIndex='4' v-if="table.forme === 'circle'" ref="circle" :config="configCircle"></v-circle>
      <v-rect v-if="getWarning && !getStyleEdition" :zIndex='5' ref="rectWarn"
        :config="configRectangleWarning"></v-rect>
    </v-group>
    <v-group :config="{ listening: false }">
      <v-text :zIndex='6' :config="configText" ref="text"></v-text>
      <v-text :zIndex='6' :config="configTextCouv" ref="text"></v-text>
      <v-text :zIndex='6' v-if="!getStyleEdition" :config="configTextTimer" ref="text"></v-text>
    </v-group>
    <v-group v-if="tableIsLock && !getStyleEdition">
      <v-path :config="configCadena"></v-path>
    </v-group>
  </v-group>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import * as resaState from '../../store/types/resa-state';
import { sendResaConfirmedMessage } from '../../tools/messageSender';
import { compareTime, dateToTimeStamp, formatTimeH, nextTime, parseTime } from '../../tools/timeTool';

export default {
  name: 'Table',
  props: ['table', 'stage', 'mainLayer', 'limits'],
  computed: {
    ...mapGetters({
      getSelectedTables: 'newRooms/getSelectedTables',
      getTables: 'newRooms/getTables',
      getClientByid: 'newClients/getClientByid',
      getModAddTable: 'newRooms/getModAddTable',
      getSelectedRoom: 'newRooms/getSelectedRoom',
      getModEdition: 'newRooms/getModEdition',
      getStyleEdition: 'newRooms/getStyleEdition',
      getUnitGrid: 'newRooms/getUnitGrid',
      getUnitTable: 'newRooms/getUnitTable',
      getModLinkTable: 'newRooms/getModLinkTable',
      getSelectedResa: 'newReservations/getSelectedResa',
      getCurrentResaById: 'newReservations/getCurrentResaById',
      getCurrentResaDataTimerById: 'newReservations/getCurrentResaDataTimerById',
      getSelectedHour: 'newReservations/getSelectedHour',
      getSelectedMainServiceData: 'newServices/getSelectedMainServiceData',
      getThisTableIsLock: 'newRooms/getThisTableIsLock',
      inCurrentService: 'newServices/inCurrentService',
      getSelectedMainService: 'newServices/getSelectedMainService',
      getSelectedDay: 'calendar/getSelectedDay',
      isVisiblePopupTakeResa: 'displayer/isVisiblePopupTakeResa',
      isVisiblePopupManageServices: 'displayer/isVisiblePopupManageServices',
      getAllInfos: 'infos/getAllInfos',
      getModSwitchTable: 'newReservations/getModSwitchTable',
      getResaToSwitch1: 'newReservations/getResaToSwitch1',
      getResaToSwitch2: 'newReservations/getResaToSwitch2',
      getFloatingSwitchTables: 'newReservations/getFloatingSwitchTables',
      getLinkedResaIdsToTable: 'newRooms/getLinkedResaIdsToTable',
      getUidPublic: 'newUsers/getUidPublic'
    }),
    tableIsLock: function () {
      return this.getThisTableIsLock({
        date: this.getSelectedDay,
        service: this.getSelectedMainService,
        room: this.table.roomid,
        id: this.table.id
      })
    },
    isLinkable: function () {
      if (this.getModLinkTable && this.getSelectedResa !== null) {
        if (this.table.isBooked && !this.table.resaId.includes(this.getSelectedResa.id)) {
          let hours = this.getHourAvaible
          if (this.getSelectedHour !== '') {
            if (hours.includes(this.getSelectedHour)) return true
            else return false
          } else if (hours.includes(this.getSelectedResa.hour)) return true
          return false
        } else if (this.tableIsLock) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    isDraggable: function () {
      if (this.getModAddTable) {
        let found = this.getSelectedTables.find((elem) => {
          return elem === this.table.id
        })
        if (found === undefined) return false
      }
      return this.getModEdition
    },
    configGroup: function () {
      if (this.mainLayer !== undefined) {
        let kRoom = this.mainLayer.getStage()
        let kLimit = this.limits.getStage()
        let kStage = this.stage.getStage()
        return {
          name: `${this.table.id}group`,
          x: this.table.x,
          y: this.table.y,
          draggable: this.isDraggable,
          dragBoundFunc: (pos) => {
            let scale = kStage.scaleX()
            // dragging rules for table, dragging with step
            let fact = this.getUnitGrid * scale
            let px = (Math.round((pos.x - kRoom.getAbsolutePosition().x) / fact) * fact) + kRoom.getAbsolutePosition().x
            let py = (Math.round((pos.y - kRoom.getAbsolutePosition().y) / fact) * fact) + kRoom.getAbsolutePosition().y
            // apply limits
            let limitRect = kLimit.getClientRect()
            px = Math.max(limitRect.x + (((this.getUnitTable * this.table.width) / 2) * scale), Math.min(limitRect.x + limitRect.width - (((this.getUnitTable * this.table.width) / 2) * scale), px))
            py = Math.max(limitRect.y + (((this.getUnitTable * this.table.height) / 2) * scale), Math.min(limitRect.y + limitRect.height - (((this.getUnitTable * this.table.height) / 2) * scale), py))
            return {
              x: px,
              y: py
            }
          }
        }
      }
    },
    getTextFill: function () {
      let selected = this.getSelectedTables.find((element) => {
        return element === this.table.id
      })
      let docStyle = getComputedStyle(document.documentElement)
      // yellow state
      if (selected || this.table.isDragging) return docStyle.getPropertyValue('--dark__main_color-dark')
      else if (!this.getStyleEdition) {
        // Green state
        if (this.table.isOccuped) return docStyle.getPropertyValue('--color_green')
        // Red state
        else if (this.getInLate) return docStyle.getPropertyValue('--color_red')
        // Grey state
        else if (this.isVisiblePopupTakeResa && (!this.getHourAvaible.includes(this.getSelectedHour) || this.tableIsLock)) return docStyle.getPropertyValue('--text_color_grey')
        else if (this.getHourAvaible.length === 0) return docStyle.getPropertyValue('--text_color_grey')
      }
      // Normal state
      return docStyle.getPropertyValue('--text_color_white')
    },
    getCadenaFill: function () {
      let selected = this.getSelectedTables.find((element) => {
        return element === this.table.id
      })
      let docStyle = getComputedStyle(document.documentElement)
      // yellow state
      if (selected || this.table.isDragging) return docStyle.getPropertyValue('--dark__main_color-dark')
      else if (!this.getStyleEdition) {
        // Green state
        if (this.table.isOccuped) return docStyle.getPropertyValue('--color_green')
        // Red state
        else if (this.getInLate) return docStyle.getPropertyValue('--color_red')
        // Grey state
        else if (this.table.isBooked || this.tableIsLock) return docStyle.getPropertyValue('--text_color_grey')
      }
      // Normal state
      return docStyle.getPropertyValue('--text_color_white')
    },
    getTextTimerFill: function () {
      let selected = this.getSelectedTables.find((element) => {
        return element === this.table.id
      })
      let docStyle = getComputedStyle(document.documentElement)
      // yellow state
      if (selected || this.table.isDragging) return docStyle.getPropertyValue('--dark__main_color-dark')
      else if (!this.getStyleEdition) {
        if (this.getWarning) return docStyle.getPropertyValue('--text_color_white')
        // Green state
        else if (this.table.isOccuped) return docStyle.getPropertyValue('--color_green')
        // Red state
        else if (this.getInLate) return docStyle.getPropertyValue('--color_red')
        // Grey state
        else if (this.isVisiblePopupTakeResa && (!this.getHourAvaible.includes(this.getSelectedHour) || this.tableIsLock)) return docStyle.getPropertyValue('--text_color_grey')
        else if (this.getHourAvaible.length === 0) return docStyle.getPropertyValue('--text_color_grey')
      }
      // Normal state
      return docStyle.getPropertyValue('--text_color_white')
    },
    getTableFill: function () {
      let selected = this.getSelectedTables.find((element) => {
        return element === this.table.id
      })
      let docStyle = getComputedStyle(document.documentElement)
      // yellow state
      if (selected || this.table.isDragging) {
        // gold state
        if (this.getIsSwitchTarget) return docStyle.getPropertyValue('--color_gold')
        return docStyle.getPropertyValue('--color_yellow')
        // Grey state
      } else if (!this.getStyleEdition && (this.getResaOnTable.length > 0)) return docStyle.getPropertyValue('--dark__main_color-dark')
      else if (!this.getStyleEdition && this.tableIsLock) return docStyle.getPropertyValue('--color_red_big_dark')
      // Normal state
      else return docStyle.getPropertyValue('--dark__main_color-light')
    },
    getStrokeFill: function () {
      let selected = this.getSelectedTables.find((element) => {
        return element === this.table.id
      })
      if (selected || this.getStyleEdition) return ''
      // visible avaibility
      if (this.getHourAvaible.length > 0 && this.getResaOnTable.length > 0) {
        if (this.getSelectedResa !== null && !this.getHourAvaible.includes(this.getSelectedResa.hour)) return ''
        if ((this.isVisiblePopupTakeResa || this.isVisiblePopupManageServices) && this.getSelectedHour !== '' && !this.getHourAvaible.includes(this.getSelectedHour)) return ''
        return '#FFFFFF'
      }
      return ''
    },
    configCadena: function () {
      return {
        y: this.configText.y + 21,
        x: 0,
        offset: {
          x: 8,
          y: (this.table.height * this.getUnitTable) / 2
        },
        data: 'M12.2666668,5.77777772 L11.2000001,5.77777772 L11.2000001,4.66666662 C11.2000001,2.82571665 9.76731208,1.33333333 8.00000007,1.33333333 C6.23268806,1.33333333 4.80000006,2.82571665 4.80000006,4.66666662 L4.80000006,5.77777772 L3.73333338,5.77777772 C3.14422934,5.77777775 2.66666667,6.27523938 2.66666667,6.88888882 C2.66666667,6.88888882 2.66666667,6.88888882 2.66666667,6.88888882 L2.66666667,13.5555554 L2.66666667,13.5555556 C2.66666676,14.1692056 3.14422987,14.6666667 3.73333334,14.6666667 L12.2666667,14.6666667 C12.8557707,14.6666667 13.3333333,14.1692056 13.3333333,13.5555556 L13.3333333,6.88888899 C13.3333333,6.27523899 12.8557701,5.77777789 12.2666667,5.77777789 L12.2666668,5.77777772 Z M8.00000007,11.8888888 C7.11634666,11.8888887 6.39999999,11.1426943 6.39999999,10.2222221 C6.40000003,9.3017499 7.11634666,8.55555546 8,8.55555546 C8.88365334,8.5555555 9.60000001,9.3017499 9.60000001,10.2222221 C9.60000001,11.1426942 8.88365334,11.8888887 8,11.8888887 Z M10.1333334,5.77777772 L5.86666673,5.77777772 L5.86666673,4.66666662 L5.86666673,4.66666696 C5.86666655,3.43936698 6.82179206,2.44444477 8.00000007,2.44444477 C9.17820808,2.44444458 10.1333334,3.43936698 10.1333334,4.66666696 C10.1333334,4.66666696 10.1333334,4.66666696 10.1333334,4.66666696 L10.1333334,5.77777772 Z',
        fill: this.getCadenaFill,
        scale: 1
      }
    },
    configRectangle: function () {
      let yellowColor = '#ffec00'
      return {
        name: `${this.table.id}rectangle`,
        fill: this.getTableFill,
        cornerRadius: 5,
        width: this.table.width * this.getUnitTable,
        height: this.table.height * this.getUnitTable,
        shadowColor: this.table.isDragging ? yellowColor : 'black',
        rotation: this.table.angle,
        stroke: this.getStrokeFill,
        strokeWidth: 1,
        offset: {
          x: (this.table.width * this.getUnitTable) / 2,
          y: (this.table.height * this.getUnitTable) / 2
        },
        shadowOpacity: 0.6,
        shadowBlur: 10,
        perfectDrawEnabled: false
      }
    },
    configRectangleWarning: function () {
      let redColor = '#e95d5d'
      return {
        name: `${this.table.id}rectangleWarn`,
        fill: redColor,
        cornerRadius: 5,
        width: 40,
        height: 15,
        y: this.configTextTimer.y - 2,
        x: 0,
        offset: {
          x: 40 / 2,
          y: (this.table.height * this.getUnitTable) / 2
        },
        perfectDrawEnabled: false
      }
    },
    configCircle: function () {
      let yellowColor = '#ffec00'
      return {
        name: `${this.table.id}circle`,
        fill: this.getTableFill,
        width: this.table.width * this.getUnitTable,
        height: this.table.height * this.getUnitTable,
        x: (this.table.width * this.getUnitTable / 2),
        y: (this.table.height * this.getUnitTable / 2),
        stroke: this.getStrokeFill,
        strokeWidth: 1,
        offset: {
          x: (this.table.width * this.getUnitTable) / 2,
          y: (this.table.height * this.getUnitTable) / 2
        },
        shadowColor: this.table.isDragging ? yellowColor : 'black',
        shadowOpacity: 0.6,
        shadowBlur: 10
      }
    },
    configText: function () {
      let yPos = (this.table.height * this.getUnitGrid) - (this.getUnitGrid / 3)
      if (this.getLinkedResaTimer !== '' && !this.getStyleEdition) yPos = yPos - 6
      else if (this.tableIsLock && !this.getStyleEdition) yPos = yPos - 8
      return {
        fontFamily: 'Comfortaa',
        name: `${this.table.id}text`,
        y: yPos,
        width: this.table.width * this.getUnitTable,
        fontStyle: 'bold',
        fontSize: this.getUnitTable / 3,
        offset: {
          x: (this.table.width * this.getUnitTable) / 2,
          y: (this.table.height * this.getUnitTable) / 2
        },
        align: 'center',
        text: this.table.id,
        fill: this.getTextFill
      }
    },
    configTextCouv: function () {
      let docStyle = getComputedStyle(document.documentElement)
      return {
        fontFamily: 'Comfortaa',
        name: `${this.table.nbCouvert}couv`,
        y: 5,
        x: 5,
        width: (this.table.width * this.getUnitTable) - 10,
        fontStyle: 'bold',
        fontSize: 11,
        offset: {
          x: (this.table.width * this.getUnitTable) / 2,
          y: (this.table.height * this.getUnitTable) / 2
        },
        align: 'right',
        text: this.table.nbCouvert,
        fill: docStyle.getPropertyValue('--color_grey_couv')
      }
    },
    configTextTimer: function () {
      return {
        fontFamily: 'Comfortaa',
        name: `${this.table.id}timer`,
        y: this.configText.y + this.configText.fontSize + 5,
        width: this.table.width * this.getUnitTable,
        fontStyle: 'bold',
        fontSize: 12,
        offset: {
          x: (this.table.width * this.getUnitTable) / 2,
          y: (this.table.height * this.getUnitTable) / 2
        },
        align: 'center',
        text: this.getLinkedResaTimer,
        fill: this.getTextTimerFill
      }
    },
    getLinkedResaTimer: function () {
      let currentResa = this.getCurrentResaOnTable
      if (currentResa && Object.keys(currentResa).length > 0 && currentResa !== undefined) return currentResa.timer
      else return ''
    },
    getLinkedResaTimerMinutes: function () {
      let currentResa = this.getCurrentResaOnTable
      if (currentResa && Object.keys(currentResa).length > 0 && currentResa !== undefined) return currentResa.difMinutes
      else return 0
    },
    getInLate: function () {
      let currentResa = this.getCurrentResaOnTable
      if (currentResa && Object.keys(currentResa).length > 0 && currentResa !== undefined) return currentResa.inLate
      else return false
    },
    getWarning: function () {
      let currentResa = this.getCurrentResaOnTable
      if (currentResa && Object.keys(currentResa).length > 0 && currentResa !== undefined) return currentResa.warningEnd
      else return false
    },
    getIsLock: function () {

    },
    getResaOnTable: function () {
      let resas = []
      if (this.table.resaId.length > 0) {
        this.table.resaId.forEach((resaId) => {
          resas.push(this.getCurrentResaDataTimerById(resaId))
        })
      } else return []
      return resas
    },
    getCurrentResaOnTable: function () {
      let resas = []
      let currentResa = {}
      if (this.table.resaId.length > 0) {
        resas = this.getResaOnTable
        resas.sort((a, b) => {
          return compareTime(a.hour, b.hour)
        })
        if (resas.length > 0) currentResa = resas[0]
        resas.forEach((resa) => {
          if (resa && resa.state === resaState.SHOW) {
            currentResa = resa
          }
        })
      }
      return currentResa
    },
    getIsSwitchTarget: function () {
      if (this.getModSwitchTable) {
        if (this.getResaToSwitch1.data !== undefined) {
          if (this.getResaToSwitch1.room !== this.getSelectedRoom) return true
          let inResa1 = this.getResaToSwitch1.tids.find((element) => {
            return element === this.table.id
          })
          if (inResa1 === undefined) return true
        }
      }
      return false
    },
    // TODO: refactor this function with newReservations/getHourAvaibleForResas function
    getHourAvaible: function () {
      let hoursDispo = []
      let existingResas = []
      let service = this.getSelectedMainServiceData
      let resasTable = this.table.resaId
      if (service) {
        let hStart = service.hMinTakeResa
        let hEnd = service.hMaxTakeResa
        let lenghtService = service.lenghtService
        let interval = service.intervalResa
        // check if current time is between hstart and hend
        let current = hStart
        // get existing resa on table
        if (resasTable.length > 0) {
          resasTable.forEach((resasId) => {
            let resa = this.getCurrentResaById(resasId)
            if (resa !== undefined && (resa.state !== resaState.DONE && resa.state !== resaState.NO_SHOW)) {
              existingResas.push({
                hstart: resa.hour,
                hend: nextTime(resa.hour, lenghtService)
              })
            }
          })
          existingResas.sort(function (a, b) {
            return compareTime(a.hstart, b.hstart)
          })
        }

        // get all interval hours
        let tmpHourDispo = []
        while (compareTime(current, hEnd) <= 0) {
          tmpHourDispo.push(current)
          current = nextTime(current, interval)
        }
        // compare existing hour and all interval
        if (existingResas.length > 0) {
          tmpHourDispo.forEach((hour) => {
            let found = false
            let hourEND = nextTime(hour, lenghtService)
            existingResas.forEach((eR) => {
              if ((compareTime(hour, eR.hstart) >= 0 && compareTime(hour, eR.hend) < 0) || (compareTime(hourEND, eR.hstart) > 0 && compareTime(hourEND, eR.hend) <= 0)) {
                found = true
              }
            })
            if (!found) hoursDispo.push(hour)
          })
        } else {
          hoursDispo = tmpHourDispo
        }
      }
      return hoursDispo
    },
    getLinkModify: function () {
      let host = `http://${window.location.hostname}`
      let ts = dateToTimeStamp(this.getSelectedResa.dateResa.day, this.getSelectedResa.dateResa.month - 1, this.getSelectedResa.dateResa.year)
      return `${host}/change/${this.getUidPublic.toString()}/${ts.toString()}/${this.getSelectedResa.id.toString()}`
    }
  },
  mounted: function () {
    if (this.table.isDragging) {
      this.$refs.container.getStage().startDrag()
    }
  },
  methods: {
    ...mapMutations({
      MOVE: 'newRooms/MOVE',
      START_MOVE: 'newRooms/START_MOVE',
      STOP_MOVE: 'newRooms/STOP_MOVE',
      SELECTED: 'newRooms/SELECTED',
      setSelectedTables: 'newRooms/setSelectedTables',
      setResaToSwitch1: 'newReservations/setResaToSwitch1',
      setResaToSwitch2: 'newReservations/setResaToSwitch2',
      setFloatingSwitchTables: 'newReservations/setFloatingSwitchTables',
      setDialogPayement: 'displayer/setDialogPayement'
    }),
    ...mapActions({
      updateLocalTable: 'newRooms/updateLocalTable',
      updateTablesLinked: 'newReservations/updateTablesLinked'
    }),
    cleanDataTable: function () {
      this.timer = ''
      this.inLate = false
      this.warningEnd = false
    },
    dragstart: function (tableGroup) {
      this.START_MOVE({
        tableId: this.table.id
      })
    },
    selected: function (tableGroup) {
      // check if table is avaible
      if (!this.isVisiblePopupTakeResa || (this.getHourAvaible.includes(this.getSelectedHour) && !this.tableIsLock)) {
        // check table if can be added or remove for selectedTables
        if (this.getTables !== null && !this.getModAddTable) {
          // get selected tables
          let tablesSelected = this.getSelectedTables.slice()
          if (this.getModEdition) tablesSelected = []
          // find table if allready selected
          let allReady = tablesSelected.findIndex((element) => {
            return element === this.table.id
          })

          if (allReady !== -1) tablesSelected.splice(allReady, 1) // remove table
          else tablesSelected.push(this.table.id) // add table

          // if mod switch on
          if (this.getModSwitchTable) {
            if (allReady !== -1) {
              if (this.getResaToSwitch1.data !== undefined) {
                // check table id is in switchResa1
                let inResa1 = this.getResaToSwitch1.tids.find((element) => {
                  return element === this.table.id
                })
                // If in resa 1 and other table is selected -> exit
                if (inResa1 !== undefined && this.getResaToSwitch1.room === this.getSelectedRoom) {
                  if (this.getResaToSwitch1.tids.length < this.getSelectedTables.length) return
                  // remove linked table of current resa unselected
                  if (this.getResaToSwitch1.tids.length > 1) {
                    tablesSelected = tablesSelected.filter(tid => !this.getResaToSwitch1.tids.includes(tid))
                  }
                  this.setResaToSwitch1({})
                }
              }
              // check if need remove selected linked resa from toswitch objects 1
              if (this.getResaToSwitch2.data !== undefined && this.getResaToSwitch2.room === this.getSelectedRoom) {
                // check table id is in switchResa1
                let inResa2 = this.getResaToSwitch2.tids.find((element) => {
                  return element === this.table.id
                })
                // If in resa 1 and other table is selected -> exit
                if (inResa2 !== undefined) {
                  // remove linked table of current resa unselected
                  if (this.getResaToSwitch2.tids.length > 1) {
                    tablesSelected = tablesSelected.filter(tid => !this.getResaToSwitch2.tids.includes(tid))
                  }
                  this.setResaToSwitch2({})
                }
              }
            } else {
              // do nothing
              // 1 - first table selected with multi resa and resaToSwtich isn't set -> exit
              if (this.getSelectedTables.length > 0 && this.getResaToSwitch1.data === undefined) return

              // add first resa linked to table toswitch objects
              let rids = this.getLinkedResaIdsToTable(this.getSelectedRoom, this.table.id)

              if (this.getResaToSwitch1.data === undefined && rids.length === 0) return
              if (this.getResaToSwitch1.data !== undefined && this.getResaToSwitch2.data !== undefined && rids.length > 0) return

              if (rids.length > 0) {
                if (this.getResaToSwitch1.data === undefined && (this.getResaToSwitch2.data === undefined || rids[0] !== this.getResaToSwitch2.data.id)) {
                  // seulement si une resa
                  if (rids.length === 1) {
                    let resa1 = this.getCurrentResaById(rids[0])
                    let resa1tables = resa1.tids.slice(0)
                    this.setResaToSwitch1({
                      state: resa1.state,
                      data: resa1,
                      tids: resa1tables,
                      room: resa1.room
                    })
                    if (resa1tables.length > 1) {
                      resa1tables.forEach((tid) => {
                        if (tid !== this.table.id) tablesSelected.push(tid)
                      })
                    }
                  }
                } else if (this.getResaToSwitch2.data === undefined && (this.getResaToSwitch1.data === undefined || rids[0] !== this.getResaToSwitch1.data.id)) {
                  let indexResa = 0
                  // if multi resa find Index resa with same resa hour
                  if (rids.length > 1) {
                    indexResa = rids.findIndex(rid => {
                      return this.getCurrentResaById(rid).hour === this.getResaToSwitch1.data.hour
                    })
                  }
                  // if no similar hours found can't be selected
                  if (indexResa !== -1) {
                    let resa2 = this.getCurrentResaById(rids[indexResa])
                    let resa2tables = resa2.tids.slice(0)
                    this.setResaToSwitch2({
                      state: resa2.state,
                      data: resa2,
                      tids: resa2tables,
                      room: resa2.room
                    })
                    if (resa2tables.length > 1) {
                      resa2tables.forEach((tid) => {
                        if (tid !== this.table.id) tablesSelected.push(tid)
                      })
                    }
                  }
                }
              }
            }
          }

          if (!this.isLinkable && this.getSelectedResa === null) {
            this.setSelectedTables(tablesSelected)
          } else if (this.isLinkable && this.getSelectedResa !== null) {
            this.setSelectedTables(tablesSelected)
            if (this.getSelectedResa.state === resaState.TO_CONFIRM && this.getSelectedResa.type === 'prepaiement' && !this.getSelectedResa.payementDone) {
              this.setDialogPayement(true)
            } else {
              if (this.getSelectedResa.state === resaState.TO_CONFIRM) {
                let client = this.getClientByid(this.getSelectedResa.cid)
                let hourFormatted = formatTimeH(parseTime(this.getSelectedResa.hour))
                // TODO: factoriser tout les sender utiliser dans un store check accept resa store reservations
                sendResaConfirmedMessage({
                  clientName: `${client.name} ${client.prenom}`,
                  clientEmail: client.email,
                  restoName: this.getAllInfos.restoName,
                  restoEmail: this.getAllInfos.restoMail,
                  dateResa: `${this.getSelectedResa.dateResa.labelDay} ${this.getSelectedResa.dateResa.day.toString()} ${this.getSelectedResa.dateResa.labelMonth} ${this.getSelectedResa.dateResa.year.toString()}`,
                  hourResa: hourFormatted,
                  message: this.getAllInfos.resaAcceptedMessage,
                  nbCouverts: this.getSelectedResa.nbCouvert,
                  adresse: this.getAllInfos.restoAdresse,
                  tel: this.getAllInfos.restoTel,
                  url: this.getLinkModify,
                  type: this.getSelectedResa.type,
                  total: this.getSelectedResa.total,
                  restoid: this.getAllInfos.restoid,
                  discount: null,
                  sendSms: this.getAllInfos.clientSmsSended !== undefined && this.getAllInfos.clientSmsSended,
                  clientTel: client.tel,
                  clientTelPreFix: client.telPreFix
                })
              }

              let roomSelected = this.getSelectedRoom
              if (tablesSelected.length === 0) roomSelected = ''
              let modifyBy = 'RESTAURANT'
              if (this.$router.currentRoute.name === 'PRedirect') modifyBy = 'PERMANENCE'

              this.updateTablesLinked({
                state: resaState.CONFIRMED,
                data: {
                  ...this.getSelectedResa,
                  modifyBy
                },
                tids: tablesSelected,
                room: roomSelected
              })
            }
          }
        }
        this.SELECTED({
          tableId: this.table.id
        })
      }
    },
    dragend: function (playerGroup) {
      if (this.$refs.rect === undefined && this.$refs.circle === undefined) {
        return
      }
      this.STOP_MOVE({
        tableId: this.table.id
      })
      this.updateLocalTable({ room: this.getSelectedRoom, table: this.table })
    },
    dragmove: function (element, evt) {
      if (this.getModEdition) this.setSelectedTables([this.table.id])
      this.MOVE({
        tableId: this.table.id,
        position: {
          x: (element.getStage().position().x),
          y: (element.getStage().position().y)
        },
        absoPos: {
          x: (element.getStage().getAbsolutePosition().x),
          y: (element.getStage().getAbsolutePosition().y)
        }
      })
    }
  }
}
</script>

<style scoped></style>
